<div class="flex flex-col h-full justify-center items-center gap-4">
  <div class="custom-loader"></div>
  @if (getText()[target()]) {
    <div class="capitalize font-bold text-2xl">{{getText()[target()]}}</div>
  }
  
</div>